import { ClienteDTO } from "@DTOS";

export abstract class ClientesUtils {
    abstract crearClienteAsync(): Promise<ClienteDTO | null>;
    abstract editarClienteAsync(cliente: ClienteDTO): Promise<ClienteDTO | null>;
}
